// extracted by mini-css-extract-plugin
module.exports = {"container":"_7246","badge":"_9401","trigger":"_4657"};